'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const SquareImageContainer = renderWithRef('SquareImageContainer', null, (a, n)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        classNames: new Set([
            'swan-square-image-container'
        ]),
        props: a,
        children: jsx("div", {
            className: "swan-square-image-container-inner",
            children: a.children
        })
    }));

export { SquareImageContainer };
